// extracted by mini-css-extract-plugin
export default {"link":"dashboard-verification-services-table-container__link__mbvzh"};